import { createFileRoute, redirect } from '@tanstack/react-router';
import { legacySignalsSearch, SIGNALS_SECTION_ID } from '../../lib/signals-search.js';

// Signals are a section of HOME, not a page; old /signals links land there with their tab and run.
export const Route = createFileRoute('/signals/')({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/dashboard',
      hash: SIGNALS_SECTION_ID,
      search: legacySignalsSearch(search as Record<string, unknown>),
      replace: true,
    });
  },
});
